import { Request,BaseApiUrl } from "./api";

// 未完成列表
export const getWeighingInListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingIn/get`, { params: params });
};
// 获取所有列表
export const getWeighingInHistryListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingIn/Histry`, { params: params });
};

//获取磅秤信息
  export const getWhsettingDetail = (params) => {
    return Request.get(`${BaseApiUrl}/api/Whsetting/GetWhsetting`, { params: params });
  };
//新增
export const addWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/Post`, params);
};
//编辑
export const editWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/Put`, params);
};
//完成
export const completeWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/Complete`, params);
};
//作废
export const cancelWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/Cancel`, params);
};
//审核
export const verifyWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/Verify`, params);
};
//取消审核
export const outVerifyWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/OutVerify`, params);
};
//入库
export const reciveWhWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/ReciveWh`, params);
};
//取消入库
export const outReciveWhWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/OutReciveWh`, params);
};
//批量删除
export const batchDeleteWeighingIn = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/BatchDelete`, params);
};
// export const batchDeleteWeighingIn = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/WeighingIn/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };

// 获取进料过磅基础数据
export const getWeighingInBaseData = () => {
  return Request.get(`${BaseApiUrl}/api/WeighingIn/GetWeighingInBaseData`);
};
//获取历史车牌详情
export const getLicense = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetLicense`, { params: params });
};


//获取打印详情
export const getPrintContent = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingIn/Print`, { params: params });
};
// 获取最后一次过磅单记录
export const getLastWeighingIn = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingIn/GetLastWeighingIn`, { params: params });
};
//自动 过皮-打印-完成-入库
export const printCompleteRecive = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingIn/PrintCompleteRecive`, params);
};
